import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import CloseIcon from '@material-ui/icons/Close';

import { ParkingName } from 'components/common';
import { Grid } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

const useStyles = makeStyles((theme) => ({
  parkingStatus: {
    height: '40px',
    display: 'flex',
  },
  blocked: {
    // marginLeft: theme.spacing(1.5),
  },
  closeButton: {
    marginRight: theme.spacing(-1.5),
  },
  lock: {
    // marginTop: 6,
  },
  inactive: {
    color: '#ADB0B8',
  },
  gridContainer: {
    borderRadius: '10px', marginTop: '5px', marginBottom: '5px'
  },
  itemName: {
    height: '50px', marginTop: '3px', paddingTop: '13px', paddingLeft: '15px'
  },
  item: {
    height: '50px', marginTop: '15px'
  }
}));

function ParkingStatus(props) {
  const classes = useStyles();

  const {
    isNew,
    detailParking,
    detailParkings,
    cardParkings,
    tabIndex,
    handleRemove,
    handleSelect,
    selected
  } = props;

  const selectedParking = cardParkings.find((p) => p.parkingId === detailParking.parkingId);
  const active = detailParkings[tabIndex].zones[0].valid;

  return (
    <Grid container style={{background: selected==tabIndex?'#eaeaea':''}} className={classes.gridContainer}>
      <Grid itemm sm={9} className={classes.itemName}>
        <div onClick={handleSelect} style={{cursor:'pointer'}}>
          <ParkingName parking={selectedParking} />
        </div>
      </Grid>

      <Grid itemm sm={1} className={classes.item}>
      <div className={classes.blocked}>
        {detailParkings[tabIndex].zones[0].blocked ? (
          <LockIcon className={classnames(classes.lock, active ? '' : classes.inactive)} color="error" />
        ) : (
          <LockOpenIcon className={classnames(classes.lock, active ? '' : classes.inactive)} color="primary" />
        )}
      </div>
      </Grid>

      <Grid item sm={1} className={classes.item}>
        <CheckBoxIcon color={active?'primary':'error'}/>
      </Grid>

      <Grid item sm={1} className={classes.item}>
      {isNew && (
        <CloseIcon
          className={classes.closeIcon}
          onClick={handleRemove(detailParking)}
        />
      )}
      </Grid>
    
    </Grid>
  );
}

ParkingStatus.propTypes = {
  isNew: PropTypes.bool.isRequired,
  detailParking: PropTypes.object.isRequired,
  detailParkings: PropTypes.array.isRequired,
  cardParkings: PropTypes.array.isRequired,
  tabIndex: PropTypes.number.isRequired,
  handleRemove: PropTypes.func.isRequired,
};

export default ParkingStatus;
